import { render, staticRenderFns } from "./CriticalCompMVK.vue?vue&type=template&id=5393f4ba&scoped=true"
import script from "./CriticalCompMVK.vue?vue&type=script&lang=js"
export * from "./CriticalCompMVK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393f4ba",
  null
  
)

export default component.exports